import styled from "styled-components";

import Text from "../Text";

const Box = styled.div`
  background-color: #fff;
  left: 0;
  padding: 24px 0;
  display: flex;
  margin-left: -24px;
  justify-content: center;
  margin-right: -24px;
`;

const FooterText = styled(Text)`
  text-align: center;
  a {
    text-decoration: underline;
  }
`;

const FooterInner = styled.div`
  text-align: center;
  opacity: 0.3;
  svg {
    margin-bottom: 16px;
  }
`;
const Footer = () => {
  return (
    <Box>
      <FooterInner>
        <svg
          width="91"
          height="16"
          viewBox="0 0 91 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M10.2397 7.71143V7.62783C11.2637 7.02179 11.7653 6.01868 11.7653 4.6394C11.7653 2.27791 10.0307 0.835938 7.43936 0.835938H0.751953V15.4646H7.64834C10.5741 15.4646 12.3086 13.8973 12.3086 11.2432C12.3086 9.52956 11.619 8.35927 10.2397 7.71143ZM3.5941 3.36461H7.0214C8.25439 3.36461 8.86043 3.90796 8.86043 4.97377C8.86043 6.03958 8.21259 6.64562 6.9587 6.64562H3.615L3.5941 3.36461ZM7.20948 12.9151H3.5941V9.1534H7.20948C8.65145 9.1534 9.38289 9.94753 9.38289 11.0342C9.38289 12.1836 8.65145 12.9151 7.20948 12.9151Z"
            fill="#909090"
          />
          <path
            d="M18.626 4.40955C17.184 4.40955 16.0764 4.76481 15.2823 5.45445C14.9048 5.78419 14.6044 6.19279 14.4021 6.6514C14.1999 7.11001 14.1009 7.60743 14.112 8.10852H16.7452C16.7452 7.29349 17.4139 6.70834 18.5633 6.70834C19.8172 6.70834 20.4441 7.35618 20.4441 8.2966V9.23702C19.6596 8.99445 18.8408 8.88151 18.02 8.90265C15.0942 8.90265 13.6313 10.1983 13.6313 12.2672C13.6313 14.2526 15.0733 15.6527 17.4348 15.6527C18.7932 15.6527 19.7963 15.2139 20.465 14.3362H20.5486L20.7576 15.4647H23.2654V8.2757C23.2654 5.9978 21.4891 4.40955 18.626 4.40955ZM20.4441 11.4313C20.4441 12.5389 19.5246 13.4375 18.1036 13.4375C17.0168 13.4375 16.4317 12.9151 16.4317 12.1419C16.4317 11.3686 17.1004 10.8671 18.2916 10.8671C19.0246 10.8554 19.7538 10.9758 20.4441 11.2223V11.4313Z"
            fill="#909090"
          />
          <path
            d="M29.4022 13.1868C27.8139 13.1868 27.0198 12.1419 27.0198 10.0311C27.0198 7.92043 27.8139 6.87553 29.4022 6.87553C29.659 6.86203 29.916 6.89955 30.1583 6.98591C30.4006 7.07228 30.6234 7.20578 30.8138 7.3787C31.0042 7.55163 31.1585 7.76055 31.2677 7.99342C31.3769 8.22629 31.439 8.47849 31.4502 8.73546H34.2714C34.1043 6.16499 32.4115 4.40955 29.4022 4.40955C27.7303 4.40955 26.4555 4.932 25.536 5.95601C24.6165 6.98002 24.1567 8.3593 24.1567 10.0311C24.1567 11.703 24.6165 13.1032 25.5569 14.1272C26.4973 15.1512 27.793 15.6527 29.4649 15.6527C32.3906 15.6527 34.1252 13.9391 34.2923 11.3686H31.4711C31.4378 11.8841 31.2011 12.3652 30.8131 12.7061C30.4252 13.0471 29.9176 13.22 29.4022 13.1868Z"
            fill="#909090"
          />
          <path
            d="M44.9609 4.80657V4.59759H41.7008L37.9182 8.81902V0H35.2642V15.4646H37.9182V10.5536L41.8053 15.4646H45.1699V15.2556L40.5723 9.63404L44.9609 4.80657Z"
            fill="#909090"
          />
          <path
            d="M51.8684 4.40951C51.2945 4.37687 50.7211 4.48333 50.1972 4.71983C49.6733 4.95633 49.2142 5.31588 48.859 5.76789H48.7754V0H45.9751V15.4646H48.4829L48.7754 14.2943H48.859C49.2142 14.7463 49.6733 15.1059 50.1972 15.3424C50.7211 15.5789 51.2945 15.6853 51.8684 15.6527C52.4927 15.6732 53.1128 15.5434 53.6765 15.2743C54.2402 15.0052 54.731 14.6046 55.1076 14.1062C55.9226 13.0822 56.3197 11.7239 56.3197 10.0311C56.3827 8.58505 55.9637 7.159 55.1285 5.97687C54.7536 5.47013 54.2607 5.06251 53.6926 4.78938C53.1245 4.51625 52.4983 4.38586 51.8684 4.40951ZM51.0742 13.1867C49.4233 13.1867 48.671 11.8701 48.671 10.0311C48.671 8.19207 49.4024 6.87549 51.0742 6.87549C52.7461 6.87549 53.4775 8.12938 53.4775 10.0311C53.4775 11.9328 52.7461 13.1867 51.0742 13.1867Z"
            fill="#909090"
          />
          <circle cx="62.9007" cy="10.1817" r="5.81819" fill="#909090" />
          <path
            d="M75.6492 4.54179C75.0585 4.51423 74.47 4.63116 73.9347 4.88243C73.3994 5.1337 72.9334 5.51173 72.5772 5.98377H72.4936L72.2846 4.75077H69.7769V15.5969H72.5772V9.57825C72.5772 8.05268 73.4758 7.07047 74.8133 7.07047C76.1508 7.07047 76.8195 7.8019 76.8195 9.24388V15.5969H79.6199V8.49154C79.599 6.04646 78.0734 4.54179 75.6492 4.54179Z"
            fill="#909090"
          />
          <path
            d="M85.6963 4.54172C84.0245 4.54172 82.7288 5.08507 81.8302 6.15088C80.9091 7.28817 80.4337 8.72193 80.4927 10.1842C80.4348 11.657 80.9348 13.0974 81.8929 14.2176C82.3801 14.7443 82.977 15.1576 83.6414 15.4284C84.3058 15.6993 85.0215 15.8209 85.7381 15.7849C86.9275 15.8376 88.0994 15.4839 89.0609 14.7818C89.4755 14.4765 89.8255 14.0922 90.0909 13.651C90.3563 13.2099 90.5319 12.7206 90.6074 12.2113H87.8697C87.5911 13.0473 86.8806 13.4652 85.7381 13.4652C84.1708 13.4652 83.3766 12.5039 83.3557 10.9574H90.7537V9.87074C90.7991 8.47661 90.3136 7.1172 89.3953 6.06728C88.9283 5.5573 88.3549 5.15628 87.7157 4.89263C87.0764 4.62899 86.387 4.50919 85.6963 4.54172ZM83.3766 9.07662C83.4393 7.76003 84.1917 6.88231 85.6963 6.88231C87.0965 6.88231 87.8279 7.76003 87.8906 9.07662H83.3766Z"
            fill="#909090"
          />
        </svg>

        <FooterText $type="smallNormal" $color="gray">
          © 2023 |{" "}
          <a
            href="https://surveys.hotjar.com/13dd9598-77c9-4013-90ec-ce073873adcd"
            target="_blank"
            rel="noreferrer noopener"
          >
            Share Feedback
          </a>
        </FooterText>
      </FooterInner>
    </Box>
  );
};

export default Footer;
